import 'popper.js';
import 'bootstrap/util';
import 'bootstrap/dropdown';
import 'bootstrap/collapse';
import 'bootstrap/modal';
import 'bootstrap/tab';
import 'bootstrap/tooltip';
import 'bootstrap-3-typeahead';
import toast from 'izitoast';

/**
 * Sometimes Babel doesn't see promise usage in dependencies.
 * This will force the polyfill on every page.
 */
window.Promise = Promise;

/**
 * Toast shortcut functions
 */
(function () {
    window.toast = {
        success: message => {
            toast.success({
                title: 'Success',
                icon: 'fas fa-check-circle',
                displayMode: 2,
                message,
            });
        },
        successBanner: message => {
            toast.show({
                title: 'Success',
                icon: 'fas fa-check-circle',
                displayMode: 2,
                position: 'topCenter',
                layout: 2,
                message,
                backgroundColor: '#AFF1BF',
            });
        },
        error: message => {
            toast.error({
                title: 'Error',
                icon: 'fas fa-exclamation-circle',
                displayMode: 2,
                message,
            });
        },
        warning: message => {
            toast.warning({
                title: 'Warning',
                icon: 'fas fa-exclamation-triangle',
                displayMode: 2,
                message,
            });
        },
        info: message => {
            toast.info({
                title: 'Information',
                icon: 'fas fa-info-circle',
                displayMode: 2,
                message,
            });
        },
    };
}());


/**
 * Need Help? modal
 */
(function () {
    $('#help__message').on('input paste', function () {
        $('#help__message__submit').prop('disabled', !$(this).val().length);
    });

    $('#help__message__submit').on('click', function () {
        const $tabPane = $(this).parents('.tab-pane');
        const message = $('#help__message').val();
        $tabPane.html('<div class="text-center p-3"><i class="fas fa-spinner fa-spin fa-fw fa-3x"></i></div>');
        $.post('./utility/help-message', {
            message,
        })
            .done(() => {
                $tabPane.html('<div class="text-center p-3"><h5>Your message has been sent successfully. We will get back to you as soon as possible.</h5><a href="#" data-toggle="modal" data-target="#help__modal">Close this window</a></div>');
            });
    });
}());


/**
 * Bootstrap sub-menu
 */
(function () {
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        const $el = $(this);
        const $parent = $(this).offsetParent('.dropdown-menu');
        if (!$(this).next().hasClass('show')) {
            $(this)
                .parents('.dropdown-menu')
                .first()
                .find('.show')
                .removeClass('show');
        }
        const $subMenu = $(this).next('.dropdown-menu');
        $subMenu.toggleClass('show');

        $(this).parent('li').toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-menu .show').removeClass('show');
        });

        if (!$parent.parent().hasClass('navbar-nav')) {
            $el.next().css({
                top: $el[0].offsetTop - 3,
                left: $parent.outerWidth() - 3,
            });
        }

        return false;
    });
}());


/**
 * Ordering site search bar autocomplete
 */
(function () {
    $('#search').typeahead({
        delay: 500,
        source: function (search, process) {
            if (!search) return [];
            return $.get(`./utility/item-search-autocomplete?search=${search}`)
                .done(response => {
                    if (response.success) {
                        return process(response.results);
                    }
                    return [];
                });
        },
        afterSelect: function (item) {
            location.href = `${$('base').attr('href')}ordering/items/${item.product}`;
        },
    });
}());


/**
 * Impersonation bar dragging
 */
(function () {
    const $impersonationBar = $('#impersonation-bar');

    function dragElement(elmnt) {
        let pos1 = 0;
        let pos2 = 0;
        elmnt.onmousedown = dragMouseDown;
        const elementWidth = elmnt.clientWidth;
        const offset = elementWidth / 2;

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            pos2 = e.clientX;
            document.onmouseup = closeDragElement;
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            pos1 = pos2 - e.clientX;
            pos2 = e.clientX;
            const newPosition = elmnt.offsetLeft - pos1;
            elmnt.style.left = Math.min(Math.max(0 + offset, newPosition), window.innerWidth - offset) + 'px';
        }

        function closeDragElement() {
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    if ($impersonationBar.length) {
        dragElement($impersonationBar.get(0));
    }
}());


$('[data-toggle="tooltip"]').tooltip();
